import { DisplayNames } from 'Roblox';
import { concatTexts } from 'core-utilities';
import recommendationsModule from '../recommendationsModule';

function creatorNameUtilities($filter, itemListConstants) {
  'ngInject';

  return {
    getNameForDisplay: creator => {
      const { userTypes, systemRobloxId } = itemListConstants;
      const { name, creatorType, creatorId } = creator;
      return userTypes[1] === creatorType && systemRobloxId !== creatorId && DisplayNames.Enabled()
        ? concatTexts.concat(['', $filter('escapeHtml')(name)])
        : $filter('escapeHtml')(name);
    }
  };
}

recommendationsModule.factory('creatorNameUtilities', creatorNameUtilities);
export default creatorNameUtilities;
